<template>
  <div>
    <el-form label-width="50px" :model="form" style="width:80%;">
      <el-form-item label="">
        <p class="b_p">企业周边500M人口：</p>
        <el-radio-group v-model="form.surround500m" size="small">
          <el-radio :label="1">
             &lt;500</el-radio>
              <el-radio :label="2">500-1000</el-radio>
              <el-radio :label="3">>1000</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="">
        <p class="b_p">企业周边5KM人口：</p>
        <el-radio-group v-model="form.surround5km" size="small">
          <el-radio :label="1">
             &lt;1万</el-radio>
              <el-radio :label="2">1万-5万</el-radio>
              <el-radio :label="3">>5万</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="" class="arr_b">
        <p class="b_p">企业雨水排口、清净下水排口、污水排口下游10km存在的环境风险受体（多选）：</p>
        <el-checkbox-group v-model="checkList" @change="changeArr">
          <div class="box-b">
            <p>E1:</p>
            <el-checkbox :disabled="disabled" label="1">乡镇及以上城镇饮用水水源（地表水或地下水）保护区</el-checkbox>
            <el-checkbox :disabled="disabled" label="2">自来水厂取水口</el-checkbox>
            <el-checkbox :disabled="disabled" label="3">水源涵养区</el-checkbox>
            <el-checkbox :disabled="disabled" label="4">自然保护区</el-checkbox>
            <el-checkbox :disabled="disabled" label="5">重要湿地</el-checkbox>
            <el-checkbox :disabled="disabled" label="6">珍稀濒危野生动植物天然集中分布区</el-checkbox>
            <el-checkbox :disabled="disabled" label="7">重要水生生物的自然产卵场及索饵场、越冬场和洄游通道</el-checkbox>
            <el-checkbox :disabled="disabled" label="8">风景名胜区</el-checkbox>
            <el-checkbox :disabled="disabled" label="9">特殊生态系统</el-checkbox>
            <el-checkbox :disabled="disabled" label="10">世界文化和自然遗产地</el-checkbox>
            <el-checkbox :disabled="disabled" label="11">红树林、珊瑚礁等滨海湿地生态系统</el-checkbox>
            <el-checkbox :disabled="disabled" label="12">珍稀、濒危海洋生物的天然集中分布区</el-checkbox>
            <el-checkbox :disabled="disabled" label="13">海洋特别保护区</el-checkbox>
            <el-checkbox :disabled="disabled" label="14">海上自然保护区</el-checkbox>
            <el-checkbox :disabled="disabled" label="15">盐场保护区</el-checkbox>
            <el-checkbox :disabled="disabled" label="16">海水浴场</el-checkbox>
            <el-checkbox :disabled="disabled" label="17">海洋自然历史遗迹</el-checkbox>
          </div>
          <div class="box-b">
            <p>E2:</p>
            <el-checkbox :disabled="disabled" label="18">水产养殖区</el-checkbox>
            <el-checkbox :disabled="disabled" label="19">天然渔场</el-checkbox>
            <el-checkbox :disabled="disabled" label="20">耕地、基本农田保护区</el-checkbox>
            <el-checkbox :disabled="disabled" label="21">富营养化水域</el-checkbox>
            <el-checkbox :disabled="disabled" label="22">基本草原</el-checkbox>
            <el-checkbox :disabled="disabled" label="23">森林公园</el-checkbox>
            <el-checkbox :disabled="disabled" label="24">地质公园</el-checkbox>
            <el-checkbox :disabled="disabled" label="25">天然林</el-checkbox>
            <el-checkbox :disabled="disabled" label="26">海滨风景游览区</el-checkbox>
            <el-checkbox :disabled="disabled" label="27">具有重要经济价值的海洋生物生存区域</el-checkbox>
          </div>
          <div class="box-b">
            <el-checkbox label="28">以上都没有</el-checkbox>
          </div>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="" class="arr_bs">
        <p class="b_p">24小时流经范围（单选）：</p>
        <el-radio-group v-model="form.throughRange24h" class="box-bb">
          <el-radio :label="1">以企业雨水排口（含泄洪渠）、清净下水排口、废水总排口算起，排水进入受纳河流最 大流速时，24小时流经范围内涉跨国界或省界的；</el-radio>
          <el-radio :label="2">24小时流经范围内不涉跨国界或省界</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="">
        <p class="b_p">影响半径(千米)：<span>{{form.affectRadius}}</span></p>
        <el-slider v-model="form.affectRadius" :min="1" :max="30" style="width:300px"></el-slider>
      </el-form-item>
    </el-form>
    <div class="map">
      <Vmap :center="center" :numberCount="form.affectRadius"></Vmap>
    </div>
  </div>
</template>
<script>
import Burst from './../../data/emer/burst.js'
import Vmap from './map'
export default {
  components: {
    Vmap
  },
  data() {
    return {
      disabled: false,
      center: [],
      points: [],
      // 基本信息
      form: {
        affectRadius: null,
        envRiskReceptor10km: null,
        planId: '',
        surround500m: null,
        surround5km: null,
        throughRange24h: null
      },
      // 多选
      checkList: [],
      isSave: false,
      pageTime:1,
    }
  },
  watch: {
    form: {
      handler() {
        let currentForms = Object.assign({}, this.form)
        currentForms.planId = sessionStorage.planIdval
        if(this.pageTime > 3){
          // console.log("保存敏感区域数据")
        this.save_sensprotection(currentForms)
          this.pageTime++;
        }else{
          this.pageTime++;
        }
        
      },
      deep: true
    }
  },
  created() {
    if (!sessionStorage.datalistobj) return
    if(!sessionStorage.planIdval) return 
    this.form.planId = sessionStorage.planIdval
    this.sensprotection_list()
    let datalistobj = JSON.parse(sessionStorage.datalistobj)
    this.center = [datalistobj.latitude, datalistobj.longitude]
  },
  mounted(){
    // if (!sessionStorage.datalistobj) return
    // if(!sessionStorage.planIdval) return 
    // this.form.planId = sessionStorage.planIdval
    // this.sensprotection_list()
    // let datalistobj = JSON.parse(sessionStorage.datalistobj)
    // this.center = [datalistobj.latitude, datalistobj.longitude]

  },
  methods: {

    // 获取列表
    sensprotection_list() {
      (async() => {
        try {
          let info = await Burst.get_sensprotection_list({
            planId: sessionStorage.planIdval
          })
          if (info.status && info.data) {
            let newform = info.data
            newform.affectRadius = parseInt(newform.affectRadius)
            this.form = newform
            this.checkList = info.data.envRiskReceptor10km.split(',')
            this.verifyResult()
          }
        } catch (err) {
          console.log(err)
        }
      })()
    },

    // 多选数据
    changeArr(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i] == 28) {
          this.checkList.splice(0, data.length, '28')
          this.disabled = true
        }
      }
      if (data.length == 0) {
        this.disabled = false
      }
      this.form.envRiskReceptor10km = this.checkList.join(',')
    },
    // 验证
    verifyResult() {
      let save_st_res = Object.assign({}, this.form)
      sessionStorage.save_st_res = JSON.stringify(save_st_res)
    },
    // 敏感保护目标信息保存(单页面)
    save_sensprotection(currentForms) {
      (async() => {
        try {
          let sen = await Burst.sensprotection_save(currentForms)
          if (sen.status) {
            this.verifyResult()
          }
        } catch (error) {
          console.log(error)
        }
      })()
    },
  }
}

</script>
<style scoped lang="stylus">
.el-checkbox,
.el-checkbox__input {
  white-space: normal
}

.el-form-item {
  margin-bottom: 20px;
}

.el-form-item__content {
  position: relative;
  left: -15px;
}

.el-checkbox-group {
  position: relative;
  left: -15px;
  label {
    display: block;
    line-height: 30px;
    &:first-child {
      margin-left: 15px;
    }
    span {
      word-break: normal;
      width: auto;
      display: block;
      white-space: pre-wrap;
      word-wrap: break-word;
      overflow: hidden;
    }
  }
}

.el-form-item__content {
  .el-radio-group {
    label {
      line-height: 30px;
      &:first-child {
        white-space: normal;
      }
    }
  }
}

.arr_bs {
  label {
    &:nth-child(2) {
      margin-left: 0;
    }
  }
}

.map {
  width: 90%;
  height: 500px;
  position: relative;
  left: 50px;
}

.b_p {
  position: relative;
  left: 0px;
  font-weight: bold;
}

.box-b {
  margin-bottom: 10px;
  p {
    margin-left: 15px;
  }
  label {
    display: inline-block;
    margin-left: 50px;
  }
}
.box-bb {
  label {
    display: inline-block;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// Sensprotection.vue?d68f8d22